import { useEffect, useState } from "react";
import Select from "react-select";
import { Alert, Snackbar } from "@mui/material";
import makeAnimated from "react-select/animated";
import SocieteAndUserService from "../../../services/societeAndUser";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { useNavigate } from "react-router-dom";
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
    zIndex: 9999,
  }),
};
const AddGroupeSociete = () => {
  const animatedComponents = makeAnimated();
  const [selectedOption, setSelectedOption] = useState([]);
  const [allSociete, setAllSociete] = useState([]);

  const [societeTitle, setSocieteTitle] = useState("");
  const [societeAdress, setSocieteAdress] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const navigate = useNavigate();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  useEffect(() => {
    SocieteAndUserService.getListSocieteForGroup(getCurrentUserId())
      .then((response) => {
        console.log("getListSocieteForGroup", response);
        let societeData = [];
        response.data.success.forEach((element) => {
          societeData.push({
            label: element.matricule + "-" + element.title,
            value: element.id,
          });
        });
        setAllSociete(societeData);
      })
      .catch((error) => {});
  }, []);
  const onChangeSocieteTitle = (event) => {
    setSocieteTitle(event.target.value);
  };
  const onChangeSocieteAdress = (event) => {
    setSocieteAdress(event.target.value);
  };
  const onChangeSelectedSociete = (e) => {
    setSelectedOption(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  }; 

  const onConfirmedAddGroupeHandler = () => {
    if (societeTitle === "") {
      setErrorAlertText("Erreur :le champ mot de passe est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeAdress === "") {
      setErrorAlertText("Erreur :le champ confirmer mot passe est vide ! ");
      setOpenErrorAlert(true);
    } else if (selectedOption.length === 0) {
      setErrorAlertText("Erreur :Aucune societe ! ");
      setOpenErrorAlert(true);
    }  else {
      let roleArray = [];

      selectedOption.forEach((element) => {
        roleArray.push(element);
      });
      console.log('role array',roleArray )
      let confirmModel = {
        title: societeTitle,
        adresse: societeAdress,
        idUserCreation: getCurrentUserId(),
        societesId:roleArray
      };
      console.log(confirmModel);

      SocieteAndUserService.addGroupe(confirmModel)
      .then((res) => {
        if (res.data.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/tiers`);
          }, 2000);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
    }
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter groupe</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title"> Ajouter un groupe</h5>
                </div>
                <div className="card-body">
                  {" "}
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Titre:</label>
                        <input
                          placeholder="Ajouter titre "
                          onChange={onChangeSocieteTitle}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="form-group">
                        <label htmlFor="inputName">Adresse:</label>
                        <input
                          placeholder="Ajouter adresse "
                          onChange={onChangeSocieteAdress}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Choisir les sociétes du groupe </label>
                        <Select
                          styles={styles}
                          isMulti
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          // defaultValue={selectedOptionWarehouseManager}
                          onChange={onChangeSelectedSociete}
                          options={allSociete}
                          placeholder={
                            allSociete.length > 0 ? "Choisir " : "Vide"
                          }
                        />
                        {/* <Select
                          className="dropdown"
                          options={allRoles}
                          value={allRoles.filter((obj) =>
                            selectedOption.includes(obj.value)
                          )}
                          onChange={onChangeSelectedRole}
                          placeholder={
                            allRoles.length > 0 ? "Choisir " : "Vide"
                          }
                          menuPlacement="top"
                          isMulti
                          isClearable
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button
                    class="btn btn-dark float-right"
                    onClick={onConfirmedAddGroupeHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default AddGroupeSociete;
